import React from 'react';
import { useState } from 'react';
import { Redirect } from 'react-router-dom';
import Navbar from '../navbar/Navbar';
import Sidebar from '../sidebar/Sidebar';
import StudentPage from './StudentPage';

const Students = ({ loggedIn, handleLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  if (!loggedIn) {
    return <Redirect to='/' />;
  }
  const openSidebar = () => {
    setSidebarOpen(true);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className='container'>
      <Navbar sidebarOpen={sidebarOpen} openSidebar={openSidebar} />
      <StudentPage />
      <Sidebar
        sidebarOpen={sidebarOpen}
        closeSidebar={closeSidebar}
        handleLogout={handleLogout}
      />
    </div>
  );
};

export default Students;
